module.exports = __webpack_public_path__ + "assets/icon-nav-leads-list-component.0d04eadd.svg";